export const DOCUMENT_UPLOAD_TAG_KEY = 'portal.document_upload' as const;
export const DOCUMENT_UPLOAD_TAG_VALUE = 'flow-document-v2' as const;
export const DOCUMENT_UPLOAD_SOURCE_TAG_KEY =
  'portal.document_upload.source' as const;

export const FLOW_DOCUMENT_UPLOAD_ANALYTICS_EVENTS = {
  STARTED: 'flow_document_upload_started',
  SUCCEEDED: 'flow_document_upload_succeeded',
  FAILED: 'flow_document_upload_failed',
  DOCUMENT_UPLOAD_ACCEPTED: 'document_upload_accepted',
  DOCUMENT_HASH_REGISTERED: 'document_hash_registered',
  DOCUMENT_DUPLICATE_DETECTED: 'document_duplicate_detected',
  DOCUMENT_PROCESSED: 'document_processed',
  DOCUMENT_FAILED: 'document_failed',
  COLLECTION_PROCESSING_STORAGE: 'flow_collection_processing_storage',
  COLLECTION_PROCESSING_TERMINAL_FAILURE:
    'flow_collection_processing_terminal_failure',
  PROCESSING_SOFT_GATE_FAIL_OPEN: 'flow_processing_soft_gate_fail_open',
  PRESERVE_IN_FLIGHT_PROCESSING_SKIPPED:
    'flow_preserve_in_flight_processing_skipped',
} as const;
